import { render, staticRenderFns } from "./TaskType.vue?vue&type=template&id=4c892476"
import script from "./TaskType.vue?vue&type=script&lang=js"
export * from "./TaskType.vue?vue&type=script&lang=js"
import style0 from "./TaskType.vue?vue&type=style&index=0&id=4c892476&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports